import { RootState } from '../types'

export const getCollectorStat = (state: RootState) => state.stats.collectorStat
